import React, { useState } from 'react';
import uuidv4 from 'uuid/v4';
import { Form, Row, Button, Empty, Spin, message } from 'antd';

import { Component as Title, EditForm as TitleForm } from './cms/Title';
import { Component as Image, EditForm as ImageForm } from './cms/Image';
import { Component as Paragraph, EditForm as ParagraphForm } from './cms/Paragraph';
import { Component as YouTube, EditForm as YouTubeForm } from './cms/YouTube';
import { Component as FAQ, EditForm as FAQForm } from './cms/FAQ';
import { Component as DocumentPreview, EditForm as DocumentPreviewForm } from './cms/DocumentPreview';
import { Component as PageTiles, EditForm as PageTilesForm } from './cms/PageTiles';
import { Component as RelatedLinks, EditForm as RelatedLinksForm } from './cms/RelatedLinks';
import { Component as Spacer, EditForm as SpacerForm } from './cms/Spacer';

export const ImportModule = ({ name, props }) => {
    switch (name) {
        case 'Title':
            return <Title key={uuidv4()} {...props} />;
        case 'Image':
            return <Image key={uuidv4()} {...props} />;
        case 'Paragraph':
            return <Paragraph key={uuidv4()} {...props} />;
        case 'YouTube':
            return <YouTube key={uuidv4()} {...props} />;
        case 'FAQ':
            return <FAQ key={uuidv4()} {...props} />;
        case 'DocumentPreview':
            return <DocumentPreview key={uuidv4()} {...props} />;
        case 'PageTiles':
            return <PageTiles key={uuidv4()} {...props} />;
        case 'RelatedLinks':
            return <RelatedLinks key={uuidv4()} {...props} />;
        case 'Spacer':
            return <Spacer key={uuidv4()} {...props} />;
        default:
            return <Empty />;
    }
};

const BaseForm = ({ form, name, props, onOk, onCancel }) => {
    const [processing, isProcessing] = useState(false);

    const onSubmit = e => {
        e.preventDefault();
        isProcessing(true);

        form.validateFields((err, values) => {
            if (form.async) {
                return onSubmitAsynchronous(err, values);
            } else {
                return onSubmitSynchronous(err, values);
            }
        });
    };

    const onSubmitAsynchronous = (err, values) => {
        if (!err) {
            new Promise((resolve, reject) => {
                form.async(resolve, reject);
            }).then(
                () => {
                    onSubmitSynchronous(err, values);
                },
                errMessage => {
                    isProcessing(false);
                    message.error(errMessage);
                }
            );
        } else {
            onSubmitSynchronous(err, values);
        }
    };

    const onSubmitSynchronous = (err, values) => {
        isProcessing(false);

        if (!err) {
            form.mapValuesToProps && (values = form.mapValuesToProps(values));
            onOk(values);
        }
    };

    const Spinner = props => {
        if (props.visible) {
            return (
                <div style={{ width: '100%', height: '100%', position: 'absolute', top: 0, left: 0, backgroundColor: 'rgba(150, 150, 150, 0.5)', cursor: 'wait' }}>
                    <Spin style={{ position: 'absolute', top: '50%', left: '50%' }} />
                </div>
            );
        }
        return '';
    };

    let newComp = <Empty />;

    switch (name) {
        case 'Title':
            newComp = <TitleForm form={form} {...props} />;
            break;
        case 'Image':
            newComp = <ImageForm form={form} {...props} />;
            break;
        case 'Paragraph':
            newComp = <ParagraphForm {...props} form={form} />;
            break;
        case 'YouTube':
            newComp = <YouTubeForm {...props} form={form} />;
            break;
        case 'FAQ':
            newComp = <FAQForm {...props} form={form} />;
            break;
        case 'DocumentPreview':
            newComp = <DocumentPreviewForm {...props} form={form} />;
            break;
        case 'PageTiles':
            newComp = <PageTilesForm {...props} form={form} />;
            break;
        case 'RelatedLinks':
            newComp = <RelatedLinksForm {...props} form={form} />;
            break;
        case 'Spacer':
            newComp = <SpacerForm {...props} form={form} />;
            break;
        default:
            break;
    }

    return (
        <Form onSubmit={onSubmit} layout="vertical">
            {newComp}

            <Row type="flex" justify="space-between">
                <Form.Item>
                    <Button type="danger" icon="close-circle" onClick={onCancel} style={{ marginRight: '1rem' }}>
                        Cancel
                    </Button>
                </Form.Item>
                <Form.Item>
                    <Button type="primary" icon="check-circle" htmlType="submit">
                        Save
                    </Button>
                </Form.Item>
            </Row>

            <Spinner visible={processing} />
        </Form>
    );
};

export const ImportForm = Form.create({ name: 'component_form' })(BaseForm);
